import { Outlet } from "react-router";
import { useAuth } from "../providers/AuthenticationProvider";

const OnlyAffiliate = () => {
	const { user, profile } = useAuth();
	if (
		user != null &&
		user.uid != "" &&
		profile != null &&
		(profile.role === "Affiliate" || profile.role == "AffiliateMaster")
	) {
		return <Outlet />;
	}
	return (
		<>
			<h1>Unauthorized</h1>
		</>
	);
};

export default OnlyAffiliate;
